import { IPagination, IStatus, IEnv } from '..';
import { IResult } from '../../data/data';

export enum ItemsActionType {
  SELECT = 'SELECT',
  LIKE = 'LIKE',
  UPDATE = 'UPDATE'
}

export enum QueryActionType {
  QUERY_UPDATED = 'QUERY_UPDATED'
}

export enum StatusActionType {
  READY = 'READY',
  NORESULTS = 'NORESULTS',
  FETCHING = 'FETCHING',
  ERROR = 'ERROR'
}

export enum PaginationActionType {
  UPDATE = 'UPDATE'
}

export enum EnvActionType {
  UPDATE_ENV = 'UPDATE_ENV'
}

export interface ISelectAction {
  type: ItemsActionType.SELECT;
  id: number;
}

export interface ILikeAction {
  type: ItemsActionType.LIKE;
  id: number;
}

export interface IItemsUpdateAction {
  type: ItemsActionType.UPDATE;
  items: IResult[];
}

export interface IQueryUpdatedAction {
  type: QueryActionType.QUERY_UPDATED;
  query: string;
}

export interface IStatusChangedAction {
  type: StatusActionType;
  status: IStatus;
}

export interface IPaginationUpdateAction {
  type: PaginationActionType;
  pagination: IPagination;
}

export interface IEnvUpdateAction {
  type: EnvActionType;
  env: IEnv;
}

export type ItemsAction = ISelectAction | ILikeAction | IItemsUpdateAction;

export type QueryAction = IQueryUpdatedAction;

export type StatusAction = IStatusChangedAction;

export type PaginationAction = IPaginationUpdateAction;

export type EnvAction = IEnvUpdateAction;
